<template>
  <div>
    <vs-card class="cstm_vx_card mt-1">
      <div slot="header" class="flex flex-wrap justify-between items-center">
        <h4>Children</h4>
        <vs-tooltip text="Add" color="primary">
          <vs-button
            v-if="multi_user == 1"
            type="border"
            icon="add"
            color="primary"
            @click="canaddchild"
          />
        </vs-tooltip>
      </div>
      <div class="vx-row">
        <vs-table :data="localvalue" class="cstm_vuexy_table w-full">
          <template slot="thead">
            <vs-th sort-key="index">Index</vs-th>
            <vs-th style="min-width: 120px">Name</vs-th>
            <vs-th style="min-width: 120px">Email</vs-th>
            <vs-th style="min-width: 120px">Phone</vs-th>
            <vs-th style="min-width: 120px">Address 1</vs-th>
            <vs-th style="min-width: 120px">Address 2</vs-th>
            <vs-th style="min-width: 120px">City</vs-th>
            <vs-th style="min-width: 120px">State</vs-th>
            <vs-th style="min-width: 120px">Zip</vs-th>
            <vs-th style="min-width: 120px">Country</vs-th>
            <vs-th style="min-width: 120px">Status</vs-th>
            <vs-th style="width: 100px">Actions</vs-th>
          </template>
          <template>
            <vs-tr :key="indextr" v-for="(item, indextr) in localvalue">
              <vs-td :data="item.leads_id">
                {{ indextr + 1 }}
              </vs-td>
              <vs-td :data="item.leads_id">
                <ImageCell 
                  :detail="item"
                  @click.native="cellSingleClicked(item.leads_id)"
                />
              </vs-td>
              <vs-td :data="item.email">
                {{ item.email }}
              </vs-td>
              <vs-td :data="item.phone">
                <ChildPhoneImageCell 
                  :phone="item.phone"
                  :country_name="item.country_details ? item.country_details.country_name : ''"
                  :country_code="item.country_details ? item.country_details.country_code : ''"
                />
              </vs-td>
              <vs-td :data="item.lead_address1">
                {{ item.lead_address1 }}
              </vs-td>
              <vs-td :data="item.lead_address2">
                {{ item.lead_address2 }}
              </vs-td>
              <vs-td :data="item.lead_city">
                {{ item.lead_city }}
              </vs-td>
              <vs-td :data="item.lead_state">
                {{ item.lead_state }}
              </vs-td>
              <vs-td :data="item.lead_zip">
                {{ item.lead_zip }}
              </vs-td>
              <vs-td :data="item.country_details.country_name">
                {{ item.country_details ? item.country_details.country_name : '' }}
              </vs-td>
              <vs-td :data="item.is_active">
                <div class="flex">
                  <toggle-button
                    :value="item.is_active === '1'"
                    :color="{
                      checked: '#35C76F',
                      unchecked: '#EA5455',
                      disabled: '#CCCCCC'
                    }"
                    class="mt-3 mr-1"
                    @change="handleToggle(indextr)"
                  />
                </div>
              </vs-td>
              <vs-td>
                <div class="flex">

                  <vs-dropdown
                    style="float: right; cursor: pointer"
                    vs-custom-content
                    vs-trigger-click
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-more-vertical"
                    ></vs-button>

                    <vs-dropdown-menu>                      
                      <vs-dropdown-item @click="openEditPopUp(item, indextr)">Edit</vs-dropdown-item>
                      <vs-dropdown-item @click="openDeletePopUp(item, indextr)">Delete</vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-card>
    <vs-popup
      classContent="popup-example"
      title="Add Child"
      :active.sync="addpopup"
    >
      <form data-vv-scope="add">
        <vs-row>
          <vs-checkbox
            v-model="sameasparentAddress"
            @change="sameAsParentAddress()"
            class="custom_Input"
            value="same"
            style="width: 100%"
            >Same as Parent's Address</vs-checkbox
          >
          <vs-col
            :vs-xs="12"
            :vs-md="12"
            :vs-lg="12"
            class="p-2"
            v-for="childfield in staticChildFields"
            :key="childfield.id"
          >
            <label class="vs-input--label w-full"
              >{{ childfield.field_label
              }}<span v-if="childfield.enabled_child" class="required"></span
            ></label>
            <vs-input
              v-if="childfield.field_name != 'platform_customer_countries_id' &&
              childfield.field_name != 'email' &&
              childfield.field_name != 'phone'"
              v-model="minor[childfield.field_name]"
              style="width: 100%"
              v-validate="childfield.enabled_child == true ? 'required' : ''"
              :data-vv-name="childfield.field_label"
              :name="childfield.field_label"
              class="custom_Input"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
            />
            <vs-input
              v-else-if="childfield.field_name == 'phone'"
              v-model="minor[childfield.field_name]"
              style="width: 100%"
              v-validate="childfield.enabled_child == true ? 'required' : ''"
              :data-vv-name="childfield.field_label"
              :name="childfield.field_label"
              class="custom_Input"
              onkeypress="return (event.charCode >= 48 && event.charCode <= 57 || event.charCode==43)"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
            />
            <vs-input
              v-else-if="childfield.field_name == 'email'"
              v-model="minor[childfield.field_name]"
              style="width: 100%"
              v-validate="childfield.enabled_child == true ? 'required|email' : ''"
              :data-vv-name="childfield.field_label"
              :name="childfield.field_label"
              class="custom_Input"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
            />
            <v-select
              v-else
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              v-model="minor[childfield.field_name]"
              v-validate="childfield.enabled_child == true ? 'required' : ''"
              :reduce="(option) => option.id"
              label="country_name"
              :name="childfield.field_label"
              :options="countryList"
              style="width: 100%"
            />
            <div
              class="flex items-center"
              style="color: rgba(var(--vs-primary), 1); font-size: 12px"
              v-if="childfield.field_name == 'phone'"
            >
              <span
                style="font-size: 14px; margin-right: 2px"
                class="material-icons-outlined"
                >info</span
              >Country code is mandatory.
            </div>
            <span
              v-show="errors.has(`add.${childfield.field_label}`)"
              class="text-danger"
              >{{ errors.first(`add.${childfield.field_label}`) }}</span
            >
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSave">Save</vs-button>
        <vs-button type="border" color="danger" @click="handleAddCancel"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      title="Edit Child"
      :active.sync="editpopup"
    >
      <form data-vv-scope="edit">
        <vs-row>
          <vs-checkbox
            v-model="sameasparentAddress"
            @change="sameAsParentAddress()"
            class="custom_Input"
            value="same"
            style="width: 100%"
            >Same as Parent's Address</vs-checkbox
          >
          <vs-col
            :vs-xs="12"
            :vs-md="12"
            :vs-lg="12"
            class="p-2"
            v-for="childfield in staticChildFields"
            :key="childfield.id"
          >
            <label class="vs-input--label w-full"
              >{{ childfield.field_label
              }}<span v-if="childfield.enabled_child" class="required"></span
            ></label>
            <vs-input
              v-if="childfield.field_name != 'platform_customer_countries_id' &&
              childfield.field_name != 'email' &&
              childfield.field_name != 'phone'"
              v-model="minor[childfield.field_name]"
              style="width: 100%"
              v-validate="childfield.enabled_child == true ? 'required' : ''"
              :data-vv-name="childfield.field_label"
              :name="childfield.field_label"
              class="custom_Input"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
            />
            <vs-input
              v-else-if="childfield.field_name == 'phone'"
              v-model="minor[childfield.field_name]"
              style="width: 100%"
              v-validate="childfield.enabled_child == true ? 'required' : ''"
              :data-vv-name="childfield.field_label"
              :name="childfield.field_label"
              class="custom_Input"
              onkeypress="return (event.charCode >= 48 && event.charCode <= 57 || event.charCode==43)"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
            />
            <vs-input
              v-else-if="childfield.field_name == 'email'"
              v-model="minor[childfield.field_name]"
              style="width: 100%"
              v-validate="childfield.enabled_child == true ? 'required|email' : ''"
              :data-vv-name="childfield.field_label"
              :name="childfield.field_label"
              class="custom_Input"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
            />

            <v-select
              v-else
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              v-model="minor[childfield.field_name]"
              v-validate="childfield.enabled_child == true ? 'required' : ''"
              :reduce="(option) => option.id"
              label="country_name"
              :name="childfield.field_label"
              :options="countryList"
              style="width: 100%"
            />
            <div
              class="flex items-center"
              style="color: rgba(var(--vs-primary), 1); font-size: 12px"
              v-if="childfield.field_name == 'phone'"
            >
              <span
                style="font-size: 14px; margin-right: 2px"
                class="material-icons-outlined"
                >info</span
              >Country code is mandatory.
            </div>
            <span
              v-show="errors.has(`edit.${childfield.field_label}`)"
              class="text-danger"
              >{{ errors.first(`edit.${childfield.field_label}`) }}</span
            >
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleEdit">Save</vs-button>
        <vs-button type="border" color="danger" @click="handleEditCancel"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      title="Delete"
      :active.sync="deletepopup"
    >
      <h4>Are you sure to delete this child?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="handleDelete">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="deletepopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import ImageCell from './ImageCell'
import ChildPhoneImageCell from './ChildPhoneImageCell'
import { ToggleButton } from 'vue-js-toggle-button'
import vSelect from 'vue-select'
import { createMinorApi, DeleteMinor, updateMinor } from '@/api/leads'
import { leadDetailsApi } from "@/api/leaddetails"
export default {
  components: {
    ImageCell,
    ChildPhoneImageCell,
    ToggleButton,
    vSelect
  },
  props: {
    children: {
      type: Array,
      required: true,
    },
    multi_user: {
      type: Number,
      required: true
    },
    staticChildFields: {
      required: true,
      type: Array,
      default: () => []
    },
    countryList: {
      required: true,
      type: Array,
      default: () => []
    },
    parent_details: {
      required: true,
      type: Object,
      default: () => { }
    },
    parent_id: {
      required: true,
      type: Number
    }
  },
  computed: {
    localvalue: {
      get() {
        return this.children;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    canaddchild() {
      if (this.parent_details.is_active == 0) {
        this.$vs.notify({
          title: "Warning",
          text: "Can\'t add new child as parent is inactive",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        })
        return false
      }
      this.addpopup = true
    },
    cellSingleClicked (leadId) {
      const routeData = this.$router.resolve({
        name: 'leadDetails',
        params: { leadId: parseInt(leadId) }
      });
      window.open(routeData.href, '_blank')
    },
    sameAsParentAddress () {
      if (this.sameasparentAddress) {
        this.minor.lead_address1 = this.parent_details.lead_address1
        this.minor.lead_address2 = this.parent_details.lead_address2
        this.minor.lead_state = this.parent_details.lead_state
        this.minor.lead_zip = this.parent_details.lead_zip
        this.minor.lead_city = this.parent_details.lead_city
        this.minor.platform_customer_countries_id =
          this.parent_details.platform_customer_countries_id
      } else {
        if (this.editpopup) {
          this.fetchLeadDetails()
        }
      }
    },
    async fetchLeadDetails () {
      try {
        const { data } = await leadDetailsApi(
          this.editItem.leads_id,
          this.$store.getters.customerId
        )
        this.leadDetails = data.data.leads_details
        this.localvalue[this.editIndex].lead_address1 = data.data.leads_details.lead_address1
        this.localvalue[this.editIndex].lead_address2 = data.data.leads_details.lead_address2
        this.localvalue[this.editIndex].lead_state = data.data.leads_details.lead_state
        this.localvalue[this.editIndex].lead_zip = data.data.leads_details.lead_zip
        this.localvalue[this.editIndex].lead_city = data.data.leads_details.lead_city
        this.localvalue[this.editIndex].platform_customer_countries_id = data.data.leads_details.platform_customer_countries_id
      } catch (e) {
      }
    },
    handleAddCancel () {
      this.addpopup = false
      this.minor = {
        lead_first_name: null,
        lead_middle_name: null,
        lead_last_name: null,
        email: null,
        mobile: null,
        lead_address1: null,
        lead_address2: null,
        lead_state: null,
        lead_city: null,
        lead_zip: null,
        platform_customer_countries_id: 1
      }
    },
    async handleSave () {
      const phoneFlag = 0;
      if (isNaN(this.minor.phone)) {
        this.$vs.notify({
          title: 'Error',
          text: 'Phone number should be digit only',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        phoneFlag = 1
      } else if (this.minor.phone.length !== 10 && this.minor.platform_customer_countries_id === 1) {
        this.$vs.notify({
          title: 'Error',
          text: 'Phone number should be 10 digits',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        phoneFlag = 1
      } else if (![9, 8, 7, 6].includes(Number(String(this.minor.phone).charAt(0))) && this.minor.platform_customer_countries_id === 1) {
        this.$vs.notify({
          title: 'Error',
          text: 'Phone number is incorrect',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        phoneFlag = 1
      }

      if (phoneFlag === 1) {
        return false
      }
      this.$validator.validateAll('add').then((result) => {
        if (result) {
          const payload = {
            leads_id: this.parent_id,
            lead_first_name: this.minor.lead_first_name,
            lead_last_name: this.minor.lead_last_name,
            lead_middle_name: this.minor.lead_middle_name,
            email: this.minor.email,
            phone: this.minor.phone,
            lead_address1: this.minor.lead_address1,
            lead_address2: this.minor.lead_address2,
            lead_city: this.minor.lead_city,
            lead_state: this.minor.lead_state,
            lead_zip: this.minor.lead_zip,
            platform_customer_countries_id:
              this.minor.platform_customer_countries_id
          }
          createMinorApi(payload, this.$store.getters.customerId)
            .then((data) => {
              const child = data.data.data.minor_details
              this.$set(this.localvalue, this.localvalue.length, child)
              this.minor = {
                lead_first_name: null,
                lead_middle_name: null,
                lead_last_name: null,
                email: null,
                mobile: null,
                lead_address1: null,
                lead_address2: null,
                lead_state: null,
                lead_city: null,
                lead_zip: null,
                platform_customer_countries_id: 1
              }
              this.addpopup = false
              this.showSuccessMessage(
                'success',
                'Child Added Successfully',
                'success'
              )
            })
            .catch((api_error) => {
              for (const [key, value] of Object.entries(
                api_error.data.errors
              )) {
                this.showSuccessMessage('Error', `${value[0]}`, 'danger')
              }
            })
        }
      })
    },
    openEditPopUp(editItemObj, editIndex) {
      if (editItemObj.is_active == 0) {
        this.$vs.notify({
          title: "Warning",
          text: "Inactive lead can not be edited",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        })
        return false
      }
      this.editpopup = true
      this.minor = editItemObj
      this.editItem = editItemObj
      this.editIndex = editIndex
    },
    openDeletePopUp(deleteObj, deleteIndex) {
      if (deleteObj.is_active == 1) {
        this.$vs.notify({
          title: "Warning",
          text: "Active lead can not be deleted",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        })
        return false
      }
      this.deletepopup = true
      this.deleteItem = deleteObj
      this.deleteIndex = deleteIndex
    },
    async handleEdit() {
      const phoneFlag = 0;
      if (isNaN(this.minor.phone)) {
        this.$vs.notify({
          title: 'Error',
          text: 'Phone number should be digit only',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        phoneFlag = 1
      } else if (this.minor.phone.length !== 10 && this.minor.platform_customer_countries_id === 1) {
        this.$vs.notify({
          title: 'Error',
          text: 'Phone number should be 10 digits',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        phoneFlag = 1
      } else if (![9, 8, 7, 6].includes(Number(String(this.minor.phone).charAt(0))) && this.minor.platform_customer_countries_id === 1) {
        this.$vs.notify({
          title: 'Error',
          text: 'Phone number is incorrect',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        phoneFlag = 1
      }

      if (phoneFlag === 1) {
        return false
      }
      try {
        const payload = {
          leads_id: this.editItem.leads_id,
          parent_leads_id: this.parent_id,
          updated_field: {
            lead_first_name: this.minor.lead_first_name,
            lead_last_name: this.minor.lead_last_name,
            lead_middle_name: this.minor.lead_middle_name,
            email: this.minor.email,
            phone: this.minor.phone,
            lead_address1: this.minor.lead_address1,
            lead_address2: this.minor.lead_address2,
            lead_city: this.minor.lead_city,
            lead_state: this.minor.lead_state,
            lead_zip: this.minor.lead_zip,
            platform_customer_countries_id:
              this.minor.platform_customer_countries_id
          }
        }

        const { data } = await updateMinor(
          payload,
          this.$store.getters.customerId
        )
        this.$vs.notify({
          title: 'Success',
          text: `Child updated successfully`,
          ...this.successProp()
        })
        this.localvalue[this.editIndex] = data.data.minor_details
        this.editpopup = false
      } catch (e) { }
    },
    handleEditCancel() {
      this.editpopup = false
    },
    async handleDelete () {
      const payload = {
        leads_id: this.deleteItem.leads_id,
        parent_leads_id: this.parent_id
      }
      await DeleteMinor(payload, this.$store.getters.customerId)

      this.$vs.notify({
        title: 'Deleted',
        text: 'User deleted Successfully',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
      const __temp = this.localvalue
      __temp.splice(this.deleteIndex, 1)
      this.deletepopup = false
    },
    async handleToggle (index) {
      try {
        const payload = {
          leads_id: this.localvalue[index].leads_id,
          parent_leads_id: this.parent_id,
          updated_field: {
            is_active: this.localvalue[index].is_active === '1' ? 0 : 1
          }
        }

        const { data } = await updateMinor(
          payload,
          this.$store.getters.customerId
        )
        this.$vs.notify({
          title: 'Success',
          text: `Child ${payload.updated_field.is_active === 0 ? 'deactivated' : 'activated'
            } Successfully`,
          ...this.successProp()
        })
        if (index === 0 && payload.updated_field.is_active === 0) {
          this.localvalue.map((item) => {
            if (item.leads_id == payload.leads_id) {
              item.is_active = 0
            }
          })
        }
        this.localvalue[index].is_active = data.data.minor_details.is_active
      } catch (e) { }
    }
  },
  data() {
    return {
      addpopup:false,
      editpopup: false,
      sameasparentAddress: false,
      editItem: {},
      editIndex: null,
      deletepopup: false,
      deleteItem: {},
      deleteIndex: null,
      leadDetails: {},
      minor: {
        lead_first_name: null,
        lead_middle_name: null,
        lead_last_name: null,
        email: null,
        mobile: null,
        lead_address1: null,
        lead_address2: null,
        lead_state: null,
        lead_city: null,
        lead_zip: null,
        platform_customer_countries_id: 1
      },
    }
  }
}
</script>
